import _Promise from 'babel-runtime/core-js/promise';
import _extends from 'babel-runtime/helpers/extends';
import _regeneratorRuntime from 'babel-runtime/regenerator';
import _asyncToGenerator from 'babel-runtime/helpers/asyncToGenerator';
import _Object$getPrototypeOf from 'babel-runtime/core-js/object/get-prototype-of';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import ArbitratorContractInterface from '@kleros/kleros-interaction/build/contracts/Arbitrator';
import EventListener from '../utils/EventListener';
import isRequired from '../utils/isRequired';
import * as arbitratorConstants from '../constants/arbitrator';
import * as errorConstants from '../constants/error';
import StandardContract from './StandardContract';
/**
 * Provides interaction with standard Arbitrable contracts
 */

var Arbitrator = function (_StandardContract) {
  _inherits(Arbitrator, _StandardContract);

  function Arbitrator() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Arbitrator);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Arbitrator.__proto__ || _Object$getPrototypeOf(Arbitrator)).call.apply(_ref, [this].concat(args))), _this), _initialiseProps.call(_this), _temp), _possibleConstructorReturn(_this, _ret);
  } // enums and constants

  /**
   * Load an arbitrable web3 contract instance
   * @param {string} contractAddress - Address of the Arbitrable contract.
   * @returns {object} web3 contract instance
   */

  /**
   * Fetch the arbitration cost.
   * @param {string} contractAddress - The address of the arbitrator contract.
   * @param {stirng} extraData - Hex string representing the extra data for the dispute.
   * @returns {number} The arbitration cost in WEI
   */

  /**
   * Fetch the appeal cost.
   * @param {string} contractAddress - The address of the arbitrator contract.
   * @param {number} disputeID - The index of the dispute.
   * @param {stirng} extraData - Hex string representing the extra data for the dispute.
   * @returns {number} The appeal cost in WEI
   */

  /**
   * Fetch the current ruling.
   * @param {string} contractAddress - The address of the arbitrator contract.
   * @param {number} disputeID - The index of the dispute.
   * @returns {number} The current ruling of the dispute.
   */

  /**
   * Fetch the current ruling.
   * @param {string} contractAddress - The address of the arbitrator contract.
   * @param {number} disputeID - The index of the dispute.
   * @returns {string} The status of the dispute.
   */

  /**
   * Fetch the data from the DisputeCreation event log. This includes the arbitrable contract,
   * the blockNumber, transactionHash and the createdAt timestamp.
   * @param {string} contractAddress - The address of the arbitrator contract.
   * @param {number} disputeID - The index of the dispute.
   * @param {object} options - Additional arguments such as toBlock and fromBlock.
   * @returns {object} Data from the dispute creation log.
   */

  /**
   * Fetch the data from the AppealDecision event log. This includes the arbitrable contract,
   * the blockNumber, transactionHash and the createdAt timestamp.
   * @param {string} contractAddress - The address of the arbitrator contract.
   * @param {number} disputeID - The index of the dispute.
   * @param {number} appealNumber - The number of the appeal.
   * @param {object} options - Additional arguments such as toBlock and fromBlock.
   * @returns {object} Data from the appeal decision log.
   */


  return Arbitrator;
}(StandardContract);

var _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.DisputeStatus = arbitratorConstants.DisputeStatus;

  this._loadContractInstance = function (contractAddress) {
    return new _this2.web3.eth.Contract(ArbitratorContractInterface.abi, contractAddress);
  };

  this.getArbitrationCost = function () {
    var _ref2 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee() {
      var contractAddress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isRequired('contractAddress');
      var extraData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '0x0';
      var contractInstance;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              contractInstance = _this2._loadContractInstance(contractAddress);
              return _context.abrupt('return', contractInstance.methods.arbitrationCost(extraData).call());

            case 2:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }));

    return function () {
      return _ref2.apply(this, arguments);
    };
  }();

  this.getAppealCost = function () {
    var _ref3 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee2() {
      var contractAddress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isRequired('contractAddress');
      var disputeID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : isRequired('disputeID');
      var extraData = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '0x0';
      var contractInstance;
      return _regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              contractInstance = _this2._loadContractInstance(contractAddress);
              return _context2.abrupt('return', contractInstance.methods.appealCost(disputeID, extraData).call());

            case 2:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this2);
    }));

    return function () {
      return _ref3.apply(this, arguments);
    };
  }();

  this.getCurrentRuling = function () {
    var _ref4 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee3() {
      var contractAddress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isRequired('contractAddress');
      var disputeID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : isRequired('disputeID');
      var contractInstance;
      return _regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              contractInstance = _this2._loadContractInstance(contractAddress);
              return _context3.abrupt('return', contractInstance.methods.currentRuling(disputeID).call());

            case 2:
            case 'end':
              return _context3.stop();
          }
        }
      }, _callee3, _this2);
    }));

    return function () {
      return _ref4.apply(this, arguments);
    };
  }();

  this.getDisputeStatus = function () {
    var _ref5 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee4() {
      var contractAddress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isRequired('contractAddress');
      var disputeID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : isRequired('disputeID');
      var contractInstance;
      return _regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              contractInstance = _this2._loadContractInstance(contractAddress);
              return _context4.abrupt('return', contractInstance.methods.disputeStatus(disputeID).call());

            case 2:
            case 'end':
              return _context4.stop();
          }
        }
      }, _callee4, _this2);
    }));

    return function () {
      return _ref5.apply(this, arguments);
    };
  }();

  this.getDisputeCreation = function () {
    var _ref6 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee5() {
      var contractAddress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isRequired('contractAddress');
      var disputeID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : isRequired('disputeID');
      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      var contractInstance, disputeCreationLog, creationLog, createdAt, args;
      return _regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              contractInstance = _this2._loadContractInstance(contractAddress);
              _context5.next = 3;
              return EventListener.getEventLogs(contractInstance, 'DisputeCreation', options.fromBlock || 0, options.toBlock || 'latest', _extends({
                _disputeID: disputeID
              }, options.filters));

            case 3:
              disputeCreationLog = _context5.sent;

              if (disputeCreationLog[0]) {
                _context5.next = 6;
                break;
              }

              throw new Error(errorConstants.CONTRACT_ERROR('No record of dispute creation for dispute ' + disputeID));

            case 6:
              if (!(disputeCreationLog.length > 1)) {
                _context5.next = 8;
                break;
              }

              throw new Error(errorConstants.CONTRACT_ERROR('More than one record of dispute creation for dispute ' + disputeID));

            case 8:
              creationLog = disputeCreationLog[0];
              _context5.next = 11;
              return new _Promise(function (resolve, reject) {
                _this2.web3.eth.getBlock(creationLog.blockNumber, function (error, result) {
                  if (error) reject(error);
                  resolve(result);
                });
              });

            case 11:
              createdAt = _context5.sent.timestamp;
              _context5.next = 14;
              return creationLog.returnValues;

            case 14:
              args = _context5.sent;
              return _context5.abrupt('return', {
                createdAt: createdAt,
                arbitrableContract: args._arbitrable,
                blockNumber: creationLog.blockNumber,
                transactionHash: creationLog.transactionHash
              });

            case 16:
            case 'end':
              return _context5.stop();
          }
        }
      }, _callee5, _this2);
    }));

    return function () {
      return _ref6.apply(this, arguments);
    };
  }();

  this.getAppealDecision = function () {
    var _ref7 = _asyncToGenerator(
    /*#__PURE__*/
    _regeneratorRuntime.mark(function _callee6() {
      var contractAddress = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : isRequired('contractAddress');
      var disputeID = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : isRequired('disputeID');
      var appealNumber = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : isRequired('appealNumber');
      var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var contractInstance, appealDecisionLog, appealLog, appealedAt, args;
      return _regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              if (!(appealNumber < 1)) {
                _context6.next = 2;
                break;
              }

              throw new Error(errorConstants.PARAMETER_ERROR('Appeal Number must be >= 1'));

            case 2:
              contractInstance = _this2._loadContractInstance(contractAddress);
              _context6.next = 5;
              return EventListener.getEventLogs(contractInstance, 'AppealDecision', options.fromBlock || 0, options.toBlock || 'latest', _extends({
                _disputeID: disputeID
              }, options.filters));

            case 5:
              appealDecisionLog = _context6.sent;
              appealLog = appealDecisionLog[appealNumber - 1];

              if (appealLog) {
                _context6.next = 9;
                break;
              }

              throw new Error(errorConstants.CONTRACT_ERROR('No record of appeal number ' + appealNumber + ' for dispute ' + disputeID));

            case 9:
              _context6.next = 11;
              return new _Promise(function (resolve, reject) {
                _this2.web3.eth.getBlock(appealLog.blockNumber, function (error, result) {
                  if (error) reject(error);
                  resolve(result);
                });
              });

            case 11:
              appealedAt = _context6.sent.timestamp;
              _context6.next = 14;
              return appealLog.returnValues;

            case 14:
              args = _context6.sent;
              return _context6.abrupt('return', {
                appealedAt: appealedAt,
                arbitrableContract: args._arbitrable,
                blockNumber: appealLog.blockNumber,
                transactionHash: appealLog.transactionHash
              });

            case 16:
            case 'end':
              return _context6.stop();
          }
        }
      }, _callee6, _this2);
    }));

    return function () {
      return _ref7.apply(this, arguments);
    };
  }();
};

export default Arbitrator;